// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
import FileUploadController from "./file_upload_controller"
import HelloController from "./hello_controller"
import TabController from "./tab_controller"
import PasskeyController from "./passkey_controller"
import RemoveItemController from "./search_list/remove_item_controller"
import SearchListController from "./search_list_controller"
import ModalController from "./modal_controller"
import ClearPendingMessagesController from "./clear_pending_messages_controller"
import ChatScrollController from "./chat_scroll_controller"
import LocalTimeController from "./local_time_controller"
import MarkdownController from "./markdown_controller"
import ExpandController from "./expand_controller"
import StreamingMessageController from "./streaming_message_controller"
import DirectUploadController from "./direct_upload_controller"
import TagsController from "./tags_controller"
import FloatingDropdownController from "./floating_dropdown_controller"
import HovercardController from "./hovercard_controller"
import ChatInputController from "./chat_input_controller"
import ToggleLabelController from "./toggle_label_controller"
import DelayedHideController from "./delayed_hide_controller"
import DownloadController from "./download_controller"
import MenuGroupController from "./menu_group_controller"
import ThinkingMessageController from "./thinking_message_controller"
import ChartController from "./chart_controller"
import GraphVisualizationController from "./graph_visualization_controller"
import PiiCleanupController from "./pii_cleanup_controller"
import BridgeElementFormController from "./bridge_element_form_controller"
application.register("auto-submit", AutoSubmitController)
application.register("file-upload", FileUploadController)
application.register("hello", HelloController)
application.register("tab", TabController)
application.register("passkey", PasskeyController)
application.register("search-list", SearchListController)
application.register("search-list-remove-item", RemoveItemController)
application.register("modal", ModalController)
application.register("clear-pending-messages", ClearPendingMessagesController)
application.register("chat-scroll", ChatScrollController)
application.register("local-time", LocalTimeController)
application.register("markdown", MarkdownController)
application.register("expand", ExpandController)
application.register("streaming-message", StreamingMessageController)
application.register("direct-upload", DirectUploadController)
application.register("tags", TagsController)
application.register("floating-dropdown", FloatingDropdownController)
application.register("hovercard", HovercardController)
application.register("chat-input", ChatInputController)
application.register("toggle-label", ToggleLabelController)
application.register("delayed-hide", DelayedHideController)
application.register("download", DownloadController)
application.register("menu-group", MenuGroupController)
application.register("thinking-message", ThinkingMessageController)
application.register("chart", ChartController)
application.register("graph-visualization", GraphVisualizationController)
application.register("pii-cleanup", PiiCleanupController)
application.register("bridge-element-form", BridgeElementFormController)
